<!--RIS-->
<!--v1.0-->
<!--重置密码-->
<!--宋增玲-->
<!--2018.08.09-->
<template>
    <div class="resetpwd-container"  v-loading.fullscreen.lock="fullscreenLoading">
        <el-row class="header">
            <el-col class="header_logo" :span="6">
                <img src="../../assets/logo.png" alt="">
            </el-col>
            <el-col class="to_login" :span="1">
                <router-link  to="/login">登录</router-link>
                </el-col>
        </el-row>
        <el-row type="flex"  justify="center" class="resetpwd_title">
            重置密码
        </el-row>
         <el-row type="flex"  justify="center" class="content">
             <el-form ref="form" :model="form" :rules="rules">
                <el-form-item  prop="mobile">
                    <el-input style="width:380px;"  v-model="form.mobile" placeholder="请输入11位手机号">
                        <i slot="prefix">
                           <svg-icon icon-class='mobile'></svg-icon>
                        </i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="vcode">
                     <el-input style="width:250px;" v-model="form.vcode" placeholder="请输入验证码">
                         <i slot="prefix">
                           <svg-icon icon-class='mobile'></svg-icon>
                        </i>
                     </el-input>
                     <el-button class="sendvcode"  @click="onSendVcode">{{sendVCodeText}}</el-button>
                </el-form-item>
                <el-form-item prop="newpwd">
                    <el-input  v-model="form.newpwd" :type="pwdType" placeholder="新密码">
                        <i slot="prefix"> <svg-icon  icon-class='lock'></svg-icon></i>
                        <i slot="suffix"  @click="onShowPwd('pwdType')">
                          <svg-icon v-if="pwdType===''" icon-class='eye'></svg-icon>
                          <svg-icon v-else icon-class='eye-close'></svg-icon>
                        </i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="newpwdConfirm">
                    <el-input v-model="form.newpwdConfirm" :type="pwdTypeConfirm" placeholder="确认密码">
                        <i slot="prefix"> <svg-icon  icon-class='lock'></svg-icon></i>
                        <i slot="suffix"  @click="onShowPwd('pwdTypeConfirm')">
                          <svg-icon v-if="pwdTypeConfirm===''" icon-class='eye'></svg-icon>
                          <svg-icon v-else icon-class='eye-close'></svg-icon>
                        </i>
                    </el-input>
                </el-form-item>
                <el-form-item style="text-align:center;">
                  <el-button style="width:380px;" type="primary" :loading="loading" @click="onSubmit('form')">重置</el-button>
                 </el-form-item>
             </el-form>
         </el-row>
    </div>
</template>

<script>
export default {
  name: 'resetpwdS',
  data() {
    // 验证手机号
    var validateMobile = (role, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('请输入手机号'))
      }
      if (value.trim().length !== 11) {
        callback(new Error('手机号必须为11位'))
      } else {
        callback()
      }
    }
    // 验证验证码
    var validateVCode = (role, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('验证码。'))
      }
      if (value.trim().length !== 6) {
        callback(new Error('验证码必须为6位。'))
      } else {
        callback()
      }
    }
    // 验证新密码
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码。'))
      } else {
        if (this.form.newpwdConfirm !== '') {
          this.$refs.form.validateField('newpwdConfirm')
        }
        callback()
      }
    }
    // 验证确认密码
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码。'))
      } else if (value !== this.form.newpwd) {
        callback(new Error('两次输入密码不一致。'))
      } else {
        callback()
      }
    }
    return {
      fullscreenLoading: false,
      sendVCodeText: '发送验证码',
      sendVCodeSecond: 60,
      pwdType: 'password',
      pwdTypeConfirm: 'password',
      form: {
        mobile: '',
        vcode: '',
        newpwd: '',
        newpwdConfirm: '',
        codeId: 0
      },
      loading: false,
      rules: {
        mobile: [{ validator: validateMobile, trigger: 'blur' }],
        vcode: [{ validator: validateVCode, trigger: 'blur' }],
        newpwd: [{ validator: validatePass, trigger: 'blur' }],
        newpwdConfirm: [{ validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit: function(formName) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$store
            .dispatch('ResetPassword', this.form)
            .then(response => {
              // 倒计时
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.$message.error('提交失败。')
          return false
        }
      })
    },
    onShowPwd: function(obj) {
      if (obj === 'pwdType') {
        this.pwdType = this.pwdType === 'password' ? '' : 'password'
      } else {
        this.pwdTypeConfirm =
          this.pwdTypeConfirm === 'password' ? '' : 'password'
      }
    },
    onSendVcode: function() {
      var vm = this
      var mobile = this.form.mobile.trim()
      if (mobile === '') {
        this.$message.error('请输入手机号。')
        return false
      }
      if (mobile.length !== 11) {
        this.$message.error('手机号必须为11位。')
        return false
      }
      if (
        this.sendVCodeText === '发送验证码' ||
        this.sendVCodeText === '重新发送'
      ) {
        this.$store
          .dispatch('SendVCode', mobile)
          .then(response => {
            // 倒计时
            vm.setSendVCodeText(this.sendVCodeSecond)
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    setSendVCodeText: function(second) {
      var vm = this
      if (second > 0) {
        second--
        this.sendVCodeText = '重新发送' + second + '秒'
        setTimeout(function() {
          vm.setSendVCodeText(second)
        }, 1000)
      } else {
        this.sendVCodeText = '重新发送'
      }
    }
  }
}
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
.resetpwd-container {
  .header {
    background: #397ee3;
    color: #fff;
    line-height: 80px;
    .header_logo {
      display: inline-block;
      width: 145px;
      height: 80px;
      float: left;
      margin-left: 2.1%;
      margin-top: 4px;
      line-height: 80px;
    }
    .header_logo img {
      display: inline-block;
      width: 145px;
      margin-left: 2.5px;
    }
    .to_login {
      float: right;
      color: #fff;
      height: 100%;
      line-height: 80px;
    }
  }
  .resetpwd_title {
    color: #397ee3;
    font-size: 28px;
    margin: 40px;
  }
  .sendvcode {
    width: 118px;
    margin-left: 10px;
    border: 1px solid #397ee3;
    color: #397ee3;
  }
}
</style>

